import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { fmtAestDateTime } from "../../lib/format";

export default function AdminArchive() {
  const [rows, setRows] = useState([]);
  async function reload() { const { data } = await api.get("/admin/archive"); setRows(data); }
  useEffect(()=>{ reload(); }, []);
  async function restore(id) { await api.post(`/companies/${id}/restore`); reload(); }
  return (
    <div className="space-y-4" data-testid="admin-archive-page">
      <h1 className="text-2xl font-bold">Archive</h1>
      <p className="text-sm text-gray-500">Archived companies are hidden from standard views but preserved here.</p>
      <div className="cesco-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600"><tr>
            <th className="text-left px-3 py-2">Company</th><th className="text-left px-3 py-2">State</th>
            <th className="text-left px-3 py-2">Archived</th><th></th>
          </tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={4} className="p-6 text-center text-gray-500">Nothing archived</td></tr>}
            {rows.map(r => (
              <tr key={r.id} className="border-t" data-testid="archive-row">
                <td className="px-3 py-2 font-medium"><Link className="hover:underline" to={`/companies/${r.id}`}>{r.company_name}</Link></td>
                <td className="px-3 py-2">{r.state}</td>
                <td className="px-3 py-2">{fmtAestDateTime(r.archived_at)}</td>
                <td className="px-3 py-2 text-right">
                  <button className="cesco-btn-ghost text-xs" onClick={()=>restore(r.id)}
                          data-testid="btn-restore-row">Restore</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
